import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import BlacklistListing from '../../components/BlacklistListing'
import useQueryGetBlacklist from '../../api/hooks/useQueryGetBlacklist'

function BlacklistPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		account: searchQuery || undefined,
		sortByCreatedAt: 'desc',
	}

	const { data, isLoading } = useQueryGetBlacklist(payload)

	return (
		<PageContainer>
			<BlacklistListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

export default withUserPermission(BlacklistPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_BLACKLIST],
})
